import React from 'react';
import './Products.css';
import ListProducts from './ListProducts';
import products from '../data/products.json';

function Products() {
  return (
    <div className="container-products">
      <div>
        <h2>Nuestros Productos</h2>
        <div className="description-products">
          <p>En Pojobox 3D, nos dedicamos a crear productos únicos utilizando tecnología de impresión 3D. Cada pieza es diseñada y fabricada con dedicación, combinando creatividad y funcionalidad para ofrecerte resultados personalizados.</p>
          <div>
            <ul className='checklist'>
              <li>Diseños adaptados a tus necesidades.</li>
              <li>Materiales de calidad como el PLA ecológico, duradero y amigable con el medio ambiente. 🌱</li>
              <li>Proceso artesanal que garantiza productos únicos y especiales.</li>
            </ul>
          </div>
          <p>Descubre nuestro catálogo y encuentra el producto perfecto para ti.</p>
        </div>
      </div>
      {/* Llamar a ListProducts con todos los productos */}
      <ListProducts products={products} />
    </div>
  );
}

export default Products;
